export const CURRENCY = {
  IDR: {
    position: 'LEADING',
    abv: 'Rp.',
    name: 'Rupiah',
  },
}
